import Routes from '../../../../../constants/routes';
import qualityEvents from '../../../../../services/quality-events/quality-events';

type HandleLinkClickProps = { item: Material; index: number };

const handleLinkClick = ({ item, index }: HandleLinkClickProps): void => {
    const inFavoritesPage = window.location.pathname === Routes.FAVORITES.path;

    inFavoritesPage && qualityEvents.favoritesPage.clickMaterialFromFavorites({ item, itemIndex: index });
};

export default handleLinkClick;
